// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"19":"77f58d15","330":"6de364cc"}[chunkId] + ".chunk.css";
};